::ng-deep particle-task-management-detail{display:flex;width:100%;height:calc(100% + 40px);margin:-20px 0}
/*# sourceMappingURL=task-management-detail.component-WNSJXYPK.css.map */
